// extracted by mini-css-extract-plugin
export default {"tableTabs":"stylesTableTabs_tableTabs__5zu4C","tableTab":"stylesTableTabs_tableTab__NfA2X","active":"stylesTableTabs_active__jjoy3"};